import script from "./TrainingAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./TrainingAutocomplete.vue?vue&type=style&index=0&id=91a3d906&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91a3d906"]])

export default __exports__